export default [
	{
		path: "/admin/reviews",
		exact: true,
		policy: "supportAdminAuth",
		component: "AdminReviews",
		mui: true,
	},
];
